import ErrorPage from '@containers/Errors/ErrorPage';
import { HTTPCodes } from '@lib/http';
import React from 'react';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: NotFound
 * @date:  18.09.2018
 * @time:  14:29
 * @refactor: 02.06.2019 00:12
 * @scope:
 */
const NotFound = () => <ErrorPage code={HTTPCodes.HTTP_NOT_FOUND} />;

export default NotFound;
